import SponsorOrderValidator from "Validators/Admin/SponsorOrder";
import { useEffect, useState } from "react";

import { HTTPErrorCallback } from "Helpers/Error";

import { UseGlobalLoading } from "Hooks/UseGlobalLoading";
import UseNotification from "Hooks/UseNotification";
import UseServices from "Hooks/UseServices";
import { useFormSchema } from "Hooks/useFormSchema";

import Button from "Components/Admin/Buttons";
import FormWrapper from "Components/Admin/Form/FormWrapper";
import Input from "Components/Admin/Form/Input";
import Select from "Components/Admin/Form/Select";

import * as S from "./styles";

const SponsorOrderForm = ({
  projectId,
  selectedSponsorOrder,
  setSelectedSponsorOrder,
  sponsorOptions,
  getProjectSponsorOrders,
}) => {
  const { api } = UseServices();
  const { showNotification } = UseNotification();
  const { loading, setLoading } = UseGlobalLoading();

  const [selectedSponsor, setSelectedSponsor] = useState(null);

  useEffect(() => {
    if (!selectedSponsorOrder?.id) return;

    setSelectedSponsor(
      sponsorOptions?.find(
        (sponsor) => sponsor.value === selectedSponsorOrder.sponsor_id,
      ),
    );
  }, [selectedSponsorOrder]);

  const methods = useFormSchema(SponsorOrderValidator, {
    defaultValues: {
      text: selectedSponsorOrder?.text,
    },
  });

  const { register, reset } = methods;

  const submit = async (data) => {
    setLoading(true);

    try {
      const route = selectedSponsorOrder?.id
        ? "/projects/update-project-sponsor-order"
        : "/projects/create-project-sponsor-order";

      await api.post(route, {
        ...data,
        order_id: selectedSponsorOrder?.id,
        project_id: projectId,
        sponsor_id: selectedSponsor?.value,
      });

      setLoading(false);

      showNotification("success", "Sucesso!", "Pedido atualizado com sucesso!");

      reset();
      setSelectedSponsorOrder(null);
      getProjectSponsorOrders(projectId);
    } catch (error) {
      setLoading(false);
      return HTTPErrorCallback(error);
    }
  };

  return (
    <S.Wrapper>
      <S.Modal>
        <FormWrapper {...methods} submit={submit}>
          <S.Section>
            <span>{selectedSponsorOrder?.id ? "Atualizar" : "Cadastrar"}</span>
            <hr />
          </S.Section>

          <Input
            {...register("text")}
            label="Texto"
            placeholder="Texto do pedido"
            required
            disabled={
              selectedSponsorOrder.status === "Aprovado" ||
              selectedSponsorOrder.status === "Reprovado"
            }
          />
          <Select
            name="sponsor_id"
            label="Patrocinador"
            options={sponsorOptions}
            placeholder="Selecione um Patrocinador"
            maxWidth="100%"
            value={selectedSponsor}
            onChange={setSelectedSponsor}
            required
            disabled={
              selectedSponsorOrder.status === "Aprovado" ||
              selectedSponsorOrder.status === "Reprovado"
            }
          />

          <S.Buttons>
            <Button
              type="button"
              outline
              text="Fechar"
              disabled={loading}
              onClick={() => setSelectedSponsorOrder(null)}
            />

            {!selectedSponsorOrder.status ||
            selectedSponsorOrder.status === "Pendente" ? (
              <Button
                type="submit"
                text={selectedSponsorOrder?.id ? "Atualizar" : "Cadastrar"}
                disabled={loading}
              />
            ) : null}
          </S.Buttons>
        </FormWrapper>
      </S.Modal>
    </S.Wrapper>
  );
};

export default SponsorOrderForm;
